<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import arrowNext from "@core/assets/icons/arrow-next.svg?raw";
	import { getApplicationToFastestPath } from "@core/schema/paths/getApplicationToFastestPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

	const { tenant } = getGlobalTemplateProps();
</script>

<section class="bg-fstphlox md:pt-24 py-14 md:pb-28 full-width grid-container">
	<h2 class="max-w-2xl xl:max-w-3xl text-center mx-auto">
		<Formatted text="Chceš se přidat do týmu Fastest? nl[[]] cw[[Pojďme to probrat]]" />
	</h2>

	<p class="text-md text-center font-medium max-w-2xl xl:max-w-4xl mx-auto mt-10 mb-1 text-fstonyx">
		<Formatted text="Ve Fastest neustále hledáme šikovné kolegy. Staneš se jedním z nás?" />
	</p>
	<p class="text-fstonyx text-md text-center max-w-3xl mx-auto">
		<Formatted text="Ozvi se přes formulář níže a pojďme si popovídat na videohovoru, nebo u kávy." />
	</p>

	<div class="max-sm:grid-container">
		<Link
			variant={ButtonVariant.Green}
			class="mx-auto flex items-center justify-center"
			href={getApplicationToFastestPath(tenant)}
		>
			Chci se přidat do týmu
			<Icon icon={arrowNext} class="ml-2 text-fstgrey-900"></Icon>
		</Link>
	</div>
</section>
